import { styled } from '@planne-software/uni/mui/material';
import { uni } from '@planne-software/uni/v2';

import { breakpoints } from '@src/common/breakpoints';
import { uniTypography } from '@src/fonts/typography/uniTypography';

export type PinCodeInputStatus = 'default' | 'success' | 'error';

export const PinFieldRoot = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${uni('scale-100')};
  width: 100%;
`;

export const PinInputRoot = styled('div')`
  display: flex;
  gap: ${uni('scale-200')};
  width: 100%;
  max-width: 100%;
`;

const cellBorderColor = (status: PinCodeInputStatus) => {
  if (status === 'success') return uni('border-success-default-rest');
  if (status === 'error') return uni('border-alert-default-rest');
  return uni('border-neutral-secondary-rest');
};

const cellTextColor = (status: PinCodeInputStatus) => {
  if (status === 'success') return uni('fg-success-default-rest');
  if (status === 'error') return uni('fg-alert-default-rest');
  return uni('fg-neutral-action-default-rest');
};

export const PinCell = styled('input', {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status?: PinCodeInputStatus }>`
  box-sizing: border-box;
  min-width: 0;
  width: auto;
  height: 4rem;
  padding: 0;
  margin: 0;
  text-align: center;
  appearance: none;
  -webkit-appearance: none;
  border: 1px solid ${({ status = 'default' }) => cellBorderColor(status)};
  border-radius: ${uni('border-radius-sm')};
  background-color: ${uni('bg-neutral-default-rest')};
  color: ${({ status = 'default' }) => cellTextColor(status)};
  outline: none;
  ${uniTypography('display-sm', 'semibold')}

  &:focus {
    border-color: ${({ status = 'default' }) =>
      status === 'default' ? uni('border-primary-default-rest') : cellBorderColor(status)};
  }

  &:disabled {
    color: ${uni('fg-disabled')};
    border-color: ${uni('border-disabled')};
  }

  @media (min-width: ${breakpoints.smallTablet}) {
    width: 5rem;
    height: 6rem;
    ${uniTypography('display-2xl', 'semibold')}
  }
`;

const messageColor = (status: PinCodeInputStatus) => {
  if (status === 'success') return uni('fg-success-default-rest');
  if (status === 'error') return uni('fg-alert-default-rest');
  return uni('fg-neutral-static-default-caption');
};

export const PinMessage = styled('p', {
  shouldForwardProp: (prop) => prop !== 'status',
})<{ status?: PinCodeInputStatus }>`
  margin: 0;
  ${uniTypography('text-sm', 'regular')}
  color: ${({ status = 'default' }) => messageColor(status)};
`;
